import { MessageCircle } from "lucide-react";
import { waLink } from "@/data/site";

export default function WhatsAppButton({
    message = "Hi Dacron Classes, I want to enquire about coaching",
}) {
    return (
        <a
            href={waLink(message)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="floating-whatsapp"
            aria-label="Chat on WhatsApp"
            className="fixed bottom-20 right-4 md:bottom-6 md:right-6 z-50"
        >
            <span className="relative flex items-center justify-center">
                <span className="absolute inline-flex h-full w-full rounded-full bg-brand-whatsapp opacity-60 animate-pulse-ring"></span>
                <span className="relative inline-flex items-center justify-center w-14 h-14 rounded-full bg-brand-whatsapp text-white shadow-xl shadow-brand-whatsapp/30 hover:scale-105 transition-transform">
                    <MessageCircle className="w-7 h-7" />
                </span>
            </span>
        </a>
    );
}
